import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../../Helpers/SectionHero';
import SectionCTA from '../../Helpers/SectionCTA';
import ServiceCard from '../../Helpers/ServiceCard';
import cctvControl from '../../../assets/images/services/cctv_control.jpg';
import { useLanguage } from '../../../i18n/LanguageContext';

const serviceIcons = ['fa-video', 'fa-camera', 'fa-mobile-screen', 'fa-screwdriver-wrench', 'fa-arrows-rotate', 'fa-fingerprint', 'fa-bell'];

const CCTV = () => {
  const { t } = useLanguage();
  const servicios = t('cctv.servicios').map((s, i) => ({ ...s, icon: serviceIcons[i] }));

  return (
    <>
      {/* Hero */}
      <SectionHero badge={t('nav.tecnologia')} title={t('cctv.title')} image={cctvControl} imagePos="center">
        <p className="text-blue-100 text-lg md:text-xl">
          {t('cctv.subtitle')}
        </p>
      </SectionHero>

      {/* Servicios — fondo claro, lenguaje visual alineado al inicio */}
      <section
        className="relative overflow-hidden py-24"
        style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
      >
        <div
          className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
          style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
        ></div>
        <div className="contain relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
            {servicios.map((item, index) => (
              <ServiceCard
                key={index}
                index={index}
                icon={item.icon}
                title={item.title}
                text={item.text}
                delay={(index % 3) * 100}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <SectionCTA
        title={t('cctv.ctaTitle')}
        text={t('cctv.ctaText')}
      />
    </>
  );
};

export default CCTV;
